import React, {useState} from "react";
import {LayerTitles} from "./Layers";


export default function GroupHeaderItem({group, currentGroup, onSelected, enabled}) {
    const active = currentGroup === group;
    const classes = [
        "hg-tabbed-border-item",
        "hg-cake-choice-group",
        "hg-cake-choice-group--" + group
    ];

    if (active) {
        classes.push('hg-cake-choice-group--active');
        classes.push('hg-tabbed-border-item--active');
    }
    classes.push((enabled ? 'hg-cake-choice-group--enabled' : 'hg-cake-choice-group--disabled'));

    return <div className={classes.join(' ')}>
        <h2
            onClick={(e) => { if (enabled && !active) { onSelected(group); } }}
            className={"hg-tabbed-border-item_inner hg-cake-choice-header"}>
            {LayerTitles[group]}
        </h2>
    </div>
}


// WEBPACK FOOTER //
// ./js/cake/GroupHeaderItem.js